import moment from "moment-timezone";

export const SESSION_STATUS = {
  PASSED: `startAt[strictly_before]=${moment().toISOString()}&order[startAt]=DESC&confirmed=true&canceled=false`,
  FUTURE: `startAt[after]=${moment().toISOString()}&order[startAt]=ASC&confirmed=true&canceled=false`,
  CANCELED: `order[startAt]=DESC&confirmed=true&canceled=true`,
};
